import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Row } from 'reactstrap';
import { useForm } from 'hooks';
import { CreateData, OOSS } from './types';
import { ApiService } from 'services';

interface Props {
  isLoading: boolean;
  ooss: OOSS[];
  onSubmit: () => void;
  setData: (data: CreateData) => void;
  data: CreateData;
}

export default function BSOForm(props: Props) {
  const { isLoading, onSubmit, ooss, setData, data } = props;

  const [values, handleChange] = useForm<CreateData>(data);

  const [remitos, setRemitos] = useState<number[]>([]);
  const [isLoadingRemitos, setIsLoadingRemitos] = useState(false);

  useEffect(() => {
    setData(values);
  }, [values]);

  useEffect(() => {
    try {
      if (-1 == values.ooss_id) {
        return;
      }

      fetchRemitos();
    } catch (err) {
      console.error(err);
    }
  }, [values.ooss_id]);

  const fetchRemitos = async () => {
    setIsLoadingRemitos(true);
    const remitos = await ApiService.getAll('submission-orders/remitos', { ooss_id: values.ooss_id });

    if (!remitos || !Array.isArray(remitos)) {
      setRemitos([]);
      setIsLoadingRemitos(false);
      return;
    }

    setRemitos(remitos);
    setIsLoadingRemitos(false);
  };

  return (
    <>
      <Form>
        <h6 className='heading-small text-muted mb-4'>Complete los datos</h6>
        <div className="pl-lg-4">
          <Row className='form-group mb-4'>
            <Col lg='6'>
              <label className='form-control-label'>Obra Social</label>
              <Input
                type='select'
                value={ values.ooss_id }
                name='ooss_id'
                className={`form-control-alternative`}
                disabled={ isLoading }
                onChange={ handleChange }
              >
                <option disabled value={-1} hidden>Seleccionar una obra social</option>
                {
                  ooss.map(item => <option key={item.id} value={item.id}>{item.codigo}</option>)
                }
              </Input>
            </Col>
            <Col lg='6'>
              <label className='form-control-label'>Remito</label>
              <Input
                type='select'
                value={ values.remito_id }
                name='remito_id'
                className={`form-control-alternative`}
                disabled={ isLoading || isLoadingRemitos || -1 == values.ooss_id }
                onChange={ handleChange }
              >
                <option disabled value={-1} hidden>Seleccionar un remito</option>
                {
                  remitos.map(remito => <option key={remito} value={remito}>{remito}</option>)
                }
              </Input>
            </Col>
          </Row>
        </div>
        <Row>
          <div className="update ml-auto mr-auto pt-4">
            <Button
              className='btn-round'
              color='success'
              title='Generar pedidos de presentacion'
              disabled={ isLoading || -1 == values.ooss_id || -1 == values.remito_id }
              onClick={ onSubmit }
            >
              Crear
            </Button>
          </div>
        </Row>
      </Form>
    </>
  );
}
